import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UserVideoComponent } from '../../../user/user-video/user-video.component';
import { InvoiceBuyDetaileComponent } from '../../../wharehouse-invoice-buy/invoice-buy-detaile/invoice-buy-detaile.component';
import { WharehouseExit2Component } from '../../../wharehouse-reception/wharehouse-exit2/wharehouse-exit2.component';
import { MaterialDetaileComponent } from "../../../wharehouse/wharehouse-material/material-detaile/material-detaile.component";
import { WharehouseOrderSaleSearialComponent } from '../../wharehouse-order-sale-searial/wharehouse-order-sale-searial.component';
import { MessageService } from '../../../service/message/message.service';
import { CardexDetaile2Component } from '../cardex-detaile2/cardex-detaile2.component';
import { InvoiceSaleDetaileComponent } from '../../../wharehouse-invoice-sale/invoice-sale-detaile/invoice-sale-detaile.component';


@Component({
  selector: 'app-cardex-list',
  templateUrl: './cardex-list.component.html',
  styleUrls: ['./cardex-list.component.scss']
})
export class CardexListComponent implements OnInit, OnDestroy {
  //**********************************************************
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));;
  public user_id: number;
  public loading: boolean = false;
  public loading2: boolean = false;
  public negative: boolean = false;
  public show_excel: boolean = false;
  public asc_desc: string = 'asc';
  public list_record: any = [];
  public search_array: any = [];
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  public site!: string;
  public count_total: number = 1;
  public excel: number = 1;
  public page: number = 1;
  public invoice_type: number = 0;
  public sum_all: number = 0;
  public buyorderId: number = 0;
  public page_number_first!: number;
  public page_number_second!: number;
  public code!: any;
  public export_code!: string;
  public search_all!: string;
  public creator!: number;
  public video!: string;
  public access_service!: number;
  public level!: number;
  public path_export!: string;
  public order!: string;
  public id!: number;
  public pre_status!: boolean;
  public next_status!: boolean;
  public new_status!: boolean;
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  public dataSource!: any;
  public displayedColumns = ['row', 'date', 'material_title', 'user', 'type_title', 'imported', 'exited', 'remain', 'price', 'sum', 'searial', 'material_id'];
  public material: number;
  public user!: number;
  public date1!: number;
  public date2!: number;
  public group_id!: number;
  public subgroup_id!: number;
  public query_invoice_type!: string;
  //*************
  constructor(
    public serverService: ServerService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public messageService: MessageService,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public dialogRef: MatDialog) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    this.site = this.serverService.get_site();
  }
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.serverService.status1(2);
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
      }
    );
    this.activatedRoute.queryParams.subscribe(
      (params: Params) => {
        this.material = params['material'];
        this.buyorderId = params['buyorderId'];
        this.query_invoice_type = params['invoiceType'];
        this.user = params['user'];
        this.date1 = params['date1'];
        this.date2 = params['date2'];
        this.page = 1;
        this.check_access(4, 1, 0, 1, 1);
      }
    );
    //**************
  }//end ngOnInit
  //****************************************************************************
  check_access(type_task: any, page: number, id: any, excel: number, loading: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.path_export = res['path_export'];
          this.check_access2(type_task, page, id, excel, loading, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access2(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, page: number, id: any, excel: number, loading: number, access_service: number): any {
    var obj = {
      'address': 6,
      'user_id': this.creator,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access(), 1, this.messageService.close());
            return false;
          }
          this.video = res['result'][0].video;
          this.loading = false;
          if (type_task == 3) {
          }
          if (type_task == 4) { this.load_data(page, excel, loading, -1); }
        }//end if
        else {
          this.message(true, this.messageService.access2(), 1, this.messageService.close());
        }
      }
    )
  }
  load_data2() {
    this.negative = true;
    this.load_data(1, 1, 1, -1);
  }
  load_data3() {
    this.negative = false;
    this.invoice_type = 0;
    this.load_data(1, 1, 1, -1);
  }
  load_data4(type: number) {
    this.invoice_type = type;
    this.load_data(1, 1, 1, -1);
  }
  sort(sort: string, asc_desc: string) {
    if (asc_desc == 'asc') this.asc_desc = 'desc';
    else this.asc_desc = 'asc';
    this.order = sort + " " + this.asc_desc;
    this.load_data(1, 1, 1, -1);
  }

  reset_sort(sort: string, asc_desc: string) {
    this.order = sort + " " + asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  load_data(page: number, excel: number, loading: number, changedRows: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5 || this.page == 1) { this.page = 1; }
    var obj = {
      'address': 6127,
      "page": this.page,
      'excel': excel,
      'user_id': this.user_id,
      'search': this.search_array,
      'search_all': this.search_all,
      'changedRows': changedRows,
      'material': this.material,
      'date1': this.date1,
      'date2': this.date2,
      'user': this.user,
      'creator': this.creator,
      'path_export': this.path_export,
      'negative': this.negative,
      'invoice_type': this.invoice_type,
      'group_id': this.group_id,
      'subgroup_id': this.subgroup_id,
      'buyorderId': this.buyorderId,
      'query_invoice_type': this.query_invoice_type,
      'order': this.order
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (excel == 1) {
            if (changedRows == -1) this.list_record = [];
            if (changedRows > 0 || changedRows == -1) {
              for (var i = 0; i < res['num']; i++) {
                res['result'][i].inventory_loading = false;
                this.list_record.push(res['result'][i]);
              }//end for
            }
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.sum_all = res['sum_all'];
            this.pages(0);
            this.serverService.change_window_resize(2, '', 0);
            this.serverService.send_services_id(this.code);
            this.serverService.send_reset({});
          }
          else if (excel == 2) {
            this.export_excel(res['export_code']);
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20 || (this.page * 20 >= this.count_total)) {
      this.page_number_second = this.count_total;
      this.next_status = true;
    }//end if
    else { this.next_status = false; }
  }
  export_excel(code: number) {
    if (code > 0) {
      var x = <any>document.getElementById("excel");
      x.href = this.site + "/export/" + code + ".xlsx";
      x.click();
    }
  }
  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code }
    })
  }
  order_ref(i: number, ref: any) {
    var material = this.list_record[i].wharehouse_material_id;
    var reception_id = this.list_record[i].wharehouse_order_reception;
    var invoice_id = this.list_record[i].wharehouse_order_invoice;
    if (ref == 'buy') {
      this.dialog.open(InvoiceBuyDetaileComponent, {
        width: '85rem',
        height: 'auto',
        disableClose: true,
        data: { type_task: 2, id: invoice_id, readonly: true, code: this.code }
      });
    }
    if (ref == 'sale') {
      this.dialog.open(InvoiceSaleDetaileComponent, {
        width: '85rem',
        height: 'auto',
        disableClose: true,
        data: { type_task: 2, id: invoice_id, readonly: true, code: this.code }
      });
    }
    else if (ref == 'reception') {
      this.dialog.open(WharehouseExit2Component, {
        'width': '85rem',
        'height': 'auto',
        data: { 'reception_id': reception_id, ref: 'exit', type: 2, code: this.code, creator: this.creator, readonly: true }
      });
    }
    else if (ref == 'firstBalance') {
      this.dialog.open(MaterialDetaileComponent, {
        width: '55rem',
        height: 'auto',
        disableClose: true,
        data: { type_task: 2, id: material, code: this.code, readonly: true }
      });
    }
  }
  open_serial(i: number, id: number, title: string, order_buy_id: number, invoice_type: string) {
    var document_type_text = 'input';
    if (invoice_type == 'sale') {
      var document_type_text = 'exit';
    }
    const dialogRef = this.dialog.open(WharehouseOrderSaleSearialComponent, {
      width: '22rem',
      height: 'auto',
      data: { id: id, title: title, document_type_text: document_type_text, order_buy_id: order_buy_id, readonly: true }
    });
  }
  check(i: number, ref: any) {
    if (ref == 'buy') {
      this.update_inventory(i);
    } else {
      this.order_ref(i, ref);
    }
  }
  update_inventory(i: number) {
    var material_id = this.list_record[i].wharehouse_material_id;
    var buy_order_id = this.list_record[i].wharehouse_order_id;
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.list_record[i].inventory_loading = true;
    var obj = {
      address: 7172,
      material_id: material_id,
      buy_order_id: buy_order_id,
      creator: this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.list_record[i].exited = res['result'][0].wharehouse_order_number_consumed;
          this.list_record[i].inventory = res['result'][0].inventory;
          this.list_record[i].inventory_loading = false;
          this.message(true, this.messageService.message('با موفقیت آپدیت شد'), 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //***************************************************************************
  filter() {
    const dialogRef = this.dialog.open(CardexDetaile2Component, {
      width: '20rem',
      height: 'auto',
      disableClose: true,
      data: { type_task: 3, search_array: this.search_array, code: this.code, creator: this.creator }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.search_array = [];
          this.search_array = res;
          this.check_access(4, 1, 0, 1, 1);
        }
      }
    )
  }
  get_bg(id: number) {
    this.id = id;
  }
  //*******************************************************************************
  change_resize() {
    //this.serverService.change_window_resize(1,'',0);
  }//end change_resize

  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
      this.loading2 = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}


